<template>
  <div class="py-5 md:px-5">
    <PageHeader class="max-w-2xl mx-auto" title="Edit Contact" :back-route="{ name: 'ContactList' }" />
    <div class="max-w-2xl mx-auto card">
      <div class="p-6">
        <contact-form mode="edit" @success="$router.push({ name: 'ContactList' })" />
      </div>
    </div>
  </div>
</template>

<script>
  import ContactForm from './ContactForm'

  export default {
    name: 'EditContact',

    metaInfo: {
      title: 'Edit Contact'
    },

    components: {
      ContactForm
    }
  }
</script>